import React from 'react';
import classNames from 'classnames';
import Icon from '../../../icon';
import { iconsList } from '../../../icon/glyphs';
import Text from '../../../text';
import { SIZES, APPEARANCES, TYPES, WEIGHTS } from './constants';
import { TYPES as ICON_APPEARANCES } from '../../../icon/constants';

const ListItem = ({
  children,
  size = SIZES.medium,
  appearance = APPEARANCES.highEmphasis,
  weight = null,
  iconGlyph = null,
  iconAppearance = ICON_APPEARANCES.inherit,
  customIcon = null,
}) => {
  const classes = classNames('ws-ui-list-item', `ws-ui-list-item--${size}`, {
    'ws-ui-list-item--with-icon': iconGlyph,
  });

  return (
    <Text
      className={classes}
      type={TYPES.listItem}
      size={size}
      appearance={appearance}
      weight={weight}
    >
      {iconGlyph && (
        <div className="ws-ui-list-item__icon">
          <Icon glyph={iconGlyph} type={iconAppearance} size="100%" />
        </div>
      )}
      {customIcon}
      {children}
    </Text>
  );
};

export default ListItem;
